'use client'

import CountryLangSelector from '@/components/CountryLangSelector'
import { TrustBox } from '@sedomicilier/material-sd'
import { useLocale, useTranslations } from 'next-intl'

const trustpilotLocaleMap: Record<string, string> = {
  nl: 'nl-BE',
  fr: 'fr-FR',
  en: 'en-GB'
}

const Footer = () => {
  const locale = useLocale()
  const t = useTranslations()
  const trustpilotLocale = trustpilotLocaleMap[locale] ?? 'nl-BE'

  return (
    <footer className='h-[80px] p-4 flex justify-between items-center bg-neutral-150'>
      <CountryLangSelector />
      <div className='tablet:flex body-2 m-auto mobile:hidden'>
        <span>{t('common.trust')}</span>
        <TrustBox locale={trustpilotLocale} />
      </div>
    </footer>
  )
}

export default Footer
